import { render, staticRenderFns } from "./CoProperty.vue?vue&type=template&id=7892a16c&"
import script from "./CoProperty.vue?vue&type=script&lang=js&"
export * from "./CoProperty.vue?vue&type=script&lang=js&"
import style0 from "./CoProperty.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports